import { map, get, take } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

import Heading from './Heading';

const CollectionBreadcrumbs = ({ breadcrumbTrail, currentCollectionTitle, trackNavigation }) => {
  const breadcrumbTrailLength = breadcrumbTrail.length - 1;
  return (
    <div className="CollectionBreadcrumbs">
      <div className="CollectionBreadcrumbs__trail">
        {map(take(breadcrumbTrail, breadcrumbTrailLength), crumb => (
          <span key={get(crumb, 'label')} className="CollectionBreadcrumbs__trail-text">
            <a
              className="CollectionBreadcrumbs__trail-text-link"
              href={get(crumb, 'linkUrl')}
              onClick={() => trackNavigation(get(crumb, 'linkUrl'))}
            >
              {get(crumb, 'label')}
            </a>{' '}
            /{' '}
          </span>
        ))}
      </div>
      <Heading>{currentCollectionTitle}</Heading>
      <style jsx>
        {`
          .CollectionBreadcrumbs__trail {
            padding-bottom: ${Theme.get('spacing') / 2}px;
          }

          .CollectionBreadcrumbs__trail-text {
            font-weight: ${Theme.get('font-weight-semi-bold')};
            font-size: ${Theme.get('font-size-smaller-px')};
            letter-spacing: ${Theme.get('letter-spacing-tight-px')};
          }

          .CollectionBreadcrumbs__trail-text-link {
            color: ${Theme.get('colors-black')};
            font-size: inherit;
          }

          @media ${largeUp} {
            .CollectionBreadcrumbs__trail {
              padding-bottom: ${Theme.get('spacing')}px;
            }

            .CollectionBreadcrumbs__trail-text-link {
              text-decoration: none;
            }

            .CollectionBreadcrumbs__trail-text-link:hover {
              text-decoration: underline;
            }
          }
        `}
      </style>
    </div>
  );
};

CollectionBreadcrumbs.propTypes = {
  breadcrumbTrail: PropTypes.arrayOf(
    PropTypes.shape({
      linkUrl: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isActive: PropTypes.bool,
    })
  ).isRequired,
  trackNavigation: PropTypes.func.isRequired,
  currentCollectionTitle: PropTypes.string.isRequired,
};

export default CollectionBreadcrumbs;
